module.exports = __webpack_public_path__ + "img/Gischt.2a50315e.jpg";